import { times } from "lodash";
import {
  Row,
  RowContainer,
} from "@circle-react-uikit/SkeletonLoader/components";

export interface NewEventsThumbnailViewProps {
  count?: number;
  disableCoverImage?: boolean;
}

export const NewEventsThumbnailView = ({
  count = 6,
  disableCoverImage = false,
}: NewEventsThumbnailViewProps) => (
  <div className="mx-6 max-w-2xl space-y-9 pb-12 md:mx-auto">
    {!disableCoverImage && (
      <div className="mb-6 flex w-full flex-col items-center space-x-6">
        <div
          id="cover-image"
          className="bg-tertiary mb-8 h-[244px] w-full shrink-0 rounded-2xl"
        />
        <div className="skeleton-loader__row-container skeleton-loader__row-container--full !m-0">
          <div className="mb-4 flex justify-between space-x-6">
            <RowContainer full>
              <Row xl half />
              <Row xl almostFull />
            </RowContainer>
            <div className="mr-4">
              <Row lg short className="!h-6" />
            </div>
          </div>
          <div className="flex justify-between space-x-6">
            <RowContainer full>
              <Row md half />
              <Row md almostFull />
              <Row md half />
            </RowContainer>
          </div>
          <div className="flex space-x-4 pt-6">
            <div className="bg-tertiary h-8 w-32 rounded-full" />
            <div className="bg-tertiary h-8 w-32 rounded-full" />
            <div className="bg-tertiary h-8 w-32 rounded-full" />
          </div>
        </div>
      </div>
    )}

    {times(count, index => (
      <div key={index} className="flex h-[100px] w-full items-center space-x-6">
        <div className="bg-tertiary h-[110px] w-[220px] shrink-0 rounded-xl" />
        <RowContainer full>
          <div className="flex justify-between space-x-6">
            <RowContainer full>
              <Row md full />
              <Row md almostFull />
            </RowContainer>
            <div className="mr-4">
              <Row lg short className="!h-6" />
            </div>
          </div>
        </RowContainer>
      </div>
    ))}
  </div>
);
